import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import * as templatesActions from './templates.actions';
import * as templatesSelectors from './templates.selectors';
import { TemplatesState } from './templates.reducer';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { OrderTemplateInterface, OrderTemplateInterfaceWithId } from '@sk/sk-interfaces';
import * as moment from 'moment';


@Injectable()
export class TemplatesFacade {
  templatesLoaded$ = this.store.pipe(select(templatesSelectors.getTemplatesLoaded));
  allTemplates$ = this.store.pipe(select(templatesSelectors.getTemplates));
  allActiveTemplates$ = this.store.pipe(select(templatesSelectors.getActiveTemplates));
  allActiveTemplatesWithCostModel$ = this.store.pipe(select(templatesSelectors.getActiveTemplatesWithCostmodel));

  allTemplatesDictionary$ = this.store.pipe(select(templatesSelectors.getTemplatesDictionary));

  addTemplatesErrors$ = this.store.pipe(select(templatesSelectors.getAddTemplateError));
  addTemplatesSuccess$ = this.store.pipe(select(templatesSelectors.getAddTemplateSuccess));

  updateTemplatesErrors$ = this.store.pipe(select(templatesSelectors.getUpdateTemplateError));
  updateTemplatesSuccess$ = this.store.pipe(select(templatesSelectors.getUpdateTemplateSuccess));

  templatesQueryError$ = this.store.pipe(select(templatesSelectors.getQueryTemplateError));


  constructor(private store: Store<TemplatesState>) {
  }


  loadTemplatesFromFirestore() {
    this.store.dispatch(templatesActions.queryFireStoreTemplates({}));
  }

  addTemplate(template: OrderTemplateInterface) {
    const newTemplate = {
      id: null,
      exists: false,
      ...template
    };
    this.store.dispatch(templatesActions.addTemplate({
      template: newTemplate
    }));
  }

  updateTemplate(templatesId: string, changes: OrderTemplateInterfaceWithId) {
    this.store.dispatch(templatesActions.updateTemplate({
      id: templatesId,
      changes
    }));
  }

  getTemplateById(id: string): Observable<OrderTemplateInterfaceWithId> {
    return this.store.select(templatesSelectors.getTemplates)
      .pipe(
        map(list => list.find(item => item.id === id))
      );
  }


  getActiveTemplatesByStaffId(staffId: string): Observable<OrderTemplateInterfaceWithId[]> {
    return this.store.select(templatesSelectors.getActiveTemplates)
      .pipe(
        map(list => list.filter(item => item.technicianId === staffId))
      );
  }


  getTemplatesByProjectId(projectId: string): Observable<OrderTemplateInterfaceWithId[]> {
    return this.store.select(templatesSelectors.getTemplates)
      .pipe(
        map(list => list.filter(item => item.projectId === projectId))
      );
  }


  getActiveTemplatesByRange(targetDate: Date): Observable<OrderTemplateInterfaceWithId[]> {
    return this.store.select(templatesSelectors.getActiveTemplates)
      .pipe(
        map(list =>
          list.filter(item => {
            const targDate = moment(targetDate);
            const templateStartDate = moment(item.startDate.toDate());
            if (templateStartDate.isBefore(targDate)) {
              return item;
            }
            if (templateStartDate.isSame(targDate)) {
              return item;
            }
          })
        )
      );
  }


  getActiveTemplatesByRangeAndTechnicanId(targetDate: Date, technicianId: string): Observable<OrderTemplateInterfaceWithId[]> {
    return this.store.select(templatesSelectors.getActiveTemplates)
      .pipe(
        map(list => list.filter(item => {
            if (item.technicianId === technicianId) {
              const targDate = moment(targetDate);
              const templateStartDate = moment(item.startDate.toDate());
              if (templateStartDate.isBefore(targDate)) {
                return item;
              }
              if (templateStartDate.isSame(targDate)) {
                return item;
              }
            }
          })
        )
      );
  }


}
